"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.START_LOADING = exports.PRE_LOADER_PROGRESS = exports.PRELOAD_START = exports.PRELOAD = exports.LoaderStatus = exports.LOAD_SOUND_SPRITE = exports.LOAD_FAILED = exports.LOADING_STARTED = exports.LOADING_COMPLETED = exports.LOADING = exports.LOADER_PROGRESS = exports.LOADED_TRANSLATIONS = exports.LOADED_FONT = exports.LOAD = exports.LANGUAGE_FILE_LOADED = exports.BG_LOADING_COMPLETE = void 0;
var LoaderStatus = exports.LoaderStatus = /*#__PURE__*/function (LoaderStatus) {
  LoaderStatus[LoaderStatus["Initiating"] = 0] = "Initiating";
  LoaderStatus[LoaderStatus["Loading"] = 1] = "Loading";
  LoaderStatus[LoaderStatus["Preload"] = 2] = "Preload";
  LoaderStatus[LoaderStatus["Completed"] = 3] = "Completed";
  LoaderStatus[LoaderStatus["Failed"] = 4] = "Failed";
  return LoaderStatus;
}({});
var START_LOADING = exports.START_LOADING = "START_LOADING";
var LOADING = exports.LOADING = "LOADING";
var LOAD = exports.LOAD = "LOAD";
var PRELOAD = exports.PRELOAD = "PRELOAD";
var PRELOAD_START = exports.PRELOAD_START = "PRELOAD_START";
var PRE_LOADER_PROGRESS = exports.PRE_LOADER_PROGRESS = "PRE_LOADER_PROGRESS";
var LOADER_PROGRESS = exports.LOADER_PROGRESS = "LOADER_PROGRESS";
var LOAD_FAILED = exports.LOAD_FAILED = "LOAD_FAILED";
var LOADING_COMPLETED = exports.LOADING_COMPLETED = "LOADING_COMPLETED";
var LOADING_STARTED = exports.LOADING_STARTED = "LOADING_STARTED";
var LOAD_SOUND_SPRITE = exports.LOAD_SOUND_SPRITE = "LOAD_SOUND_SPRITE";
var LOADED_FONT = exports.LOADED_FONT = "LOADED_FONT";
var LOADED_TRANSLATIONS = exports.LOADED_TRANSLATIONS = "LOADED_TRANSLATIONS";
var BG_LOADING_COMPLETE = exports.BG_LOADING_COMPLETE = "BG_LOADING_COMPLETE";
var LANGUAGE_FILE_LOADED = exports.LANGUAGE_FILE_LOADED = "LANGUAGE_FILE_LOADED";

//Actions
//# sourceMappingURL=types.js.map